import axios from './axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import { config } from '../config'
const base_url = config.apiUrl

const model = 'exam/'

export const examService = {
  getAll,
  createExam,
  getQuestions,
  sendResult,
  getPayments,
  paid,
  getMemberExams,
  getMemberExamQuestions
}

function getAll(memberId) {
  const url = base_url + model + memberId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function createExam(memberId) {
  const url = base_url + model + memberId + '/createExam'
  // console.log(url);
  // console.log(authHeaderJson());
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeaderJson() })
}

function getQuestions(examId) {
  const url = base_url + model + examId + '/getQuestions'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeaderJson() })
}

function sendResult(dto) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getPayments(dto) {
  const url = base_url + 'payment'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function paid(examId) {
  const url = base_url + model + examId + '/paid'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeaderJson() })
}

function getMemberExams(memberId) {
  const url = base_url + model + memberId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeaderJson() })
}

function getMemberExamQuestions(examId) {
  const url = base_url + model + examId + '/getExamResultQuestion'
  // console.log(url);
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeaderJson() })
}
